/* @ngInject */
export function AdministrationAccountsDepartmentEmployeesController($ngRedux, $state, $uiRouterGlobals, NavigationService) {
    var ctrl = this;
    var unsubscribe = angular.noop;

    ctrl.$onInit = function() {
        var navConfig = NavigationService.getConfig($state.$current);
        ctrl.colorName = navConfig.colorName;
        ctrl.icon = navConfig.icon;

        unsubscribe = $ngRedux.connect(mapStateToThis, {})(ctrl);
    };

    ctrl.selectDepartments = function() {
        $ngRedux.dispatch({
            type: 'TAB_SELECT',
            id: 'app.administration.accounts.departments',
            state: 'app.administration.accounts.departments.list'
        });
    };

    ctrl.selectRooms = function() {
        $state.go('app.administration.accounts.rooms', $uiRouterGlobals.params, {reload: 'app.administration.accounts'});
    };

    ctrl.selectEquipment = function() {
        $ngRedux.dispatch({
            type: 'TAB_SELECT',
            id: 'app.administration.accounts.departments',
            state: 'app.administration.accounts.departments.equipment',
            stateParams: $uiRouterGlobals.params
        });
    };

    ctrl.$onDestroy = function() {
        unsubscribe();
    };

    function mapStateToThis(state) {
        return {
            title: [
                state.administration.administrationAccountsHeadOffice.name,
                state.administration.administrationAccountsSiteLocation.data.name,
                state.administration.administrationAccountsDepartment.data.typeName,
                'Employees'
            ].filter(function(item) {
                return _.isString(item);
            }).join(' » ')
        };
    }
}
